import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

import useStyles from './styles';

const TextLink = (props) => {
    const { to, children, external, color } = props;

    const classes = useStyles();
    const className = clsx(classes.root, classes[`${color}Color`]);

    if (external) {
        return (
            <Link href={to} className={className}>
                {children}
            </Link>
        );
    }

    return (
        <Link to={to} component={RouterLink} className={className}>
            {children}
        </Link>
    );
};

TextLink.defaultProps = {
    external: false,
    color: 'default',
};

TextLink.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    external: PropTypes.bool,
    color: PropTypes.oneOf(['actHealth', 'default']),
};

export default TextLink;
